var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{attrs:{"title":'Unlink'},on:{"click":_vm.onClick}},[_c('i',{staticClass:"far fa-unlink fs-16"})])}
var staticRenderFns = []

export { render, staticRenderFns }